<!-- src/app/settings/settings.component.html -->
<div class="settings-container">
  <div class="header">
    <div class="content">
      <ion-icon name="settings-outline"></ion-icon>
      <div class="title">Settings</div>
    </div>
    <div class="cancel-button" (click)="cancelButton()">
      <ion-icon name="close-outline"></ion-icon>
    </div>
  </div>

  <div class="main-container">
    <div class="sidebar">
      <ng-container *ngFor="let tab of settingsConfig; let i = index">
        <button
          class="sidebar-options"
          (click)="selectTab(tab.key, i)"
          [ngClass]="{ active: tab.key === selectedTab }"
          [disabled]="isTabSwitchDisabled(tab.key)"
          *ngIf="isTabVisible(tab)"
        >
          <ion-icon [name]="tab.icon"></ion-icon>
          {{ tab.name }}
        </button>
      </ng-container>
    </div>

    <div class="settings-content">
      <!-- The host for dynamic components is now always present -->
      <ng-container #tabContentHost></ng-container>

      <!-- The default settings template is now conditionally rendered based on currentTabConfig.component -->
      <ng-container *ngIf="!currentTabConfig?.component">
        <span class="span-title"
          ><b>{{ currentTabConfig?.title }}</b></span
        >

        <div *ngFor="let setting of currentTabConfig?.settings">
          <div *ngIf="isSettingVisible(setting)">
            <div class="purpose">
              <span class="settings-label"
                ><b>{{ setting.label }}</b></span
              >
              <p class="setting-purpose-title">{{ setting.purpose }}</p>
              <app-nbs-select-dropdown
                class="filter"
                [value]="getSelectedValue(setting.filter_key)"
                [multiSelect]="false"
                [searchable]="false"
                [placeholder]="setting.placeholder"
                [options]="getUserSettingOptions(setting.filter_key)"
                [showLoader]="isInitialAPILoaded"
                [enableClearAll]="false"
                (selectedItemChange)="onSettingsChange(setting.filter_key, $event)"
              >
              </app-nbs-select-dropdown>
            </div>
          </div>
        </div>
        <div class="buttons-container">
          <ion-button class="card-button" [disabled]="isButtonDisabled() || loading" (click)="saveSettings()">
            <ion-spinner *ngIf="loading" name="circular" color="primary"></ion-spinner>
            <span>{{ loading ? "Applying Settings.." : "Save" }}</span>
          </ion-button>
        </div>
        <div class="edit-note" *ngIf="isSettingBeingSaved">
          Note : Editing Recs Pref would be enabled once the user settings is completed
        </div>
      </ng-container>
    </div>
  </div>
</div>
